<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Fattoria Le Pupille</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Proprio come la fiamma olimpica, i segreti della vinificazione non muoiono mai. Caso in questione è Fattoria
                        Le Pupille; sebbene la tenuta sia ancora alla sua prima generazione (quasi sconosciuta in questo
                        industria), la titolare Elisabetta Geppetti ha chiesto consiglio alle leggende; entra da Antinori
                        leggendario enologo, il compianto Giacomo Tachis (creatore del vino pregiato più costoso d'Italia
                        Sassicaia) così come Riccardo Cotarella, famoso per Château Latour.
                    </div>

                    <div class="howto-title2">Madonna della Maremma</div>
                    <div class="howto-text">
                        Avendo deciso a 20 anni che non era tagliata per una vita di studio, ha iniziato a lavorare a Le
                        Pupille - una piccola azienda vinicola a conduzione familiare. Consulenza sul reimpianto per Cabernet Sauvignon e
                        Sangiovese, dal 1987 Fattoria Le Pupille ha rilasciato la sua prima annata dell'ormai famoso 1987
                        Saffredi - una miscela xx. Elisabetta era in vigna da appena sette anni. La tenuta è
                        è nato il primo supertuscan.
                        <br><br>
                        Nel 1992 è stata nominata prima donna presidente del Consorzio Morellino di Scansano insieme a
                        il loro premio "Vignaiolo dell'anno". Sotto il suo governo, la tenuta è cresciuta da due piccoli
                        ettari ai 75 ettari di vigneto che è oggi (la tenuta è un mssive
                        420 ettari in totale, con seminativi e ulivi che costituiscono il resto).
                    </div>

                    <div class="howto-title2">Stupendo Saffreti!</div>
                    <div class="howto-text">
                        Potrebbe usare uve francesi ma il vino è tutto italiano. Quello che è iniziato come un puro
                        Al Cabernet Savignon sono state aggiunte (e sottratte) quantità variabili di Merlot, Syrah e Alicante
                        negli ultimi 25 anni e oggi Elisabetta ha optato per un Cabernet Sauvignon, Merlot
                        e miscela Petit Verdot.
                        <br><br>
                        Fattoria Le Pupille ha all'attivo otto denominazioni, ma è il Safretti che cattura le nostre attenzioni sia dal punto di vista enologico che degli investimenti. La miscela si è lentamente evoluta
                        da quella prima bottiglia (nel secondo trimestre del 2019 era disponibile solo una bottiglia del famoso vino
                        mercato secondario, a un prezzo molto ragionevole di € 100) in uno dei vini pregiati più ambiti del
                        mercato.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Fattoria Le Pupille</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Ähnlich wie die olympische Flamme erlöschen die Geheimnisse der guten Weinherstellung nie. Ein typisches Beispiel ist Fattoria
                        Le Pupille; obwohl das Anwesen noch in der ersten Generation ist (was in dieser Zeit fast unbekannt ist).
                        Industrie) hat Inhaberin Elisabetta Geppetti den Rat von Legenden eingeholt; Betreten Sie Antinoris
                        legendärer Winzer, der verstorbene Giacomo Tachis (Schöpfer des teuersten edlen Weins Italiens).
                        Sassicaia) sowie Riccardo Cotarella, berühmt für das Château Latour.
                    </div>

                    <div class="howto-title2">Unsere Liebe Frau von der Maremma</div>
                    <div class="howto-text">
                        Nachdem sie mit 20 entschieden hatte, dass sie für ein Leben als Studentin nicht geeignet sei, begann sie bei Le zu arbeiten
                        Pupille – ein kleines, familiengeführtes Weingut. Beratung bei Neuanpflanzungen für Cabernet Sauvignon und
                        Sangiovese, 1987 brachte Fattoria Le Pupille ihren ersten Jahrgang des mittlerweile berühmten 1987 heraus
                        Saffredi – eine xx-Mischung. Elisabetta war erst seit sieben Jahren im Weinberg. Das Anwesen
                        Der erste Supertoskaner ist geboren.
                        <br><br>
                        1992 wurde sie zur ersten weiblichen Präsidentin des Morellino di Scansano-Konsortiums ernannt
                        Sie erhielten die Auszeichnung „Winzer des Jahres“. Unter ihrer Leitung ist das Anwesen aus nur zwei kleinen Häusern gewachsen
                        Hektar auf die 75 Hektar Weinberge, die es heute ist (das Anwesen ist ein Massiv).
                        Insgesamt 420 Hektar, der Rest besteht aus Acker- und Olivenbäumen.
                    </div>

                    <div class="howto-title2">Stupendo Saffreti!</div>
                    <div class="howto-text">
                        Möglicherweise verwendet sie französische Trauben, aber der Wein ist rein italienisch. Was als reines begann
                        Bei Cabernet Savignon wurden unterschiedliche Mengen an Merlot, Syrah und Alicante hinzugefügt (und entfernt).
                        In den letzten 25 Jahren und heute hat sich Elisabetta für einen Cabernet Sauvignon, Merlot, entschieden
                        und Petit Verdot-Mischung.
                        <br><br>
                        Die Fattoria Le Pupille hat acht Appellationen, aber es ist der Safretti, der unsere Aufmerksamkeit sowohl aus önologischer als auch aus investitionstechnischer Sicht auf sich zieht. Die Mischung hat sich langsam weiterentwickelt
                        Von dieser ersten Flasche an (im zweiten Quartal 2019 war nur eine Flasche des berühmten Weins erhältlich
                        (Sekundärmarkt, zu einem sehr günstigen Preis von 100 €) in einen der begehrtesten erlesenen Weine der Welt verwandelt
                        Markt.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Fattoria Le Pupille</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Tout comme la flamme olympique, les secrets de la vinification fine ne meurent jamais. Le cas typique est Fattoria
                        Le Pupille; bien que le domaine en soit encore à sa première génération (presque inédit dans cette
                        l'industrie), la propriétaire Elisabetta Geppetti a demandé conseil aux légendes ; entrez chez Antinori
                        vigneron légendaire, feu Giacomo Tachis (créateur du vin fin le plus cher d'Italie
                        Sassicaia) ainsi que Riccardo Cotarella, de la renommée Château Latour.
                    </div>

                    <div class="howto-title2">Notre-Dame de la Maremme</div>
                    <div class="howto-text">
                        Ayant décidé à 20 ans qu'elle n'était pas faite pour une vie d'études, elle a commencé à travailler au
                        Pupille - un petit domaine viticole familial. Conseil en replantation en Cabernet Sauvignon et
                        Sangiovese, en 1987 Fattoria Le Pupille sort son premier millésime du désormais célèbre 1987
                        Saffredi - un mélange xx. Elisabetta était au vignoble depuis seulement sept ans. Le domaine
                        premier super toscan est né.
                        <br><br>
                        En 1992, elle a été nommée la première femme présidente du Consortium Morellino di Scansano avec
                        leur prix de « Vigneron de l'année ». Sous sa direction, le domaine est passé d'un petit deux
                        d'hectares aux 75 hectares de vignes qu'il est aujourd'hui (le domaine est un immense
                        420 hectares au total, avec des terres arables et des oliviers constituant le reste).
                    </div>

                    <div class="howto-title2">Stupendo Saffreti!</div>
                    <div class="howto-text">
                        Elle utilise peut-être des raisins français, mais le vin est entièrement italien. Ce qui a commencé comme un pur
                        Le cabernet savignon a eu des quantités variables de merlot, de syrah et d'alicante ajoutées (et soustraites)
                        tout au long des 25 dernières années et aujourd'hui Elisabetta a opté pour un Cabernet Sauvignon, Merlot
                        et assemblage Petit Verdot.
                        <br><br>
                        Fattoria Le Pupille compte huit appellations à son actif, mais c'est le Safretti qui retient notre attention tant d'un point de vue œnologique que d'investissement. Le mélange a lentement évolué
                        à partir de cette première bouteille (au deuxième trimestre 2019, une seule bouteille du célèbre vin était disponible sur le
                        marché secondaire, à un prix très raisonnable de 100 €) en l'un des vins fins les plus convoités du
                        marché.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Fattoria Le Pupille</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Much like the Olympic flame, the secrets of fine winemaking never die. Case in point is Fattoria
                        Le Pupille; although the estate is still in its first generation (almost unheard of in this
                        industry), owner Elisabetta Geppetti has sought the advice of legends; enter Antinori’s
                        legendary winemaker, the late Giacomo Tachis (creator of Italy’s most expensive fine wine
                        Sassicaia) as well as Riccardo Cotarella, of Château Latour fame.
                    </div>

                    <div class="howto-title2">Our Lady of Maremma</div>
                    <div class="howto-text">
                        Having decided at 20 that she wasn’t cut out for a life of studying, she began working at Le
                        Pupille - a small family run wine estate. Advising on replanting for Cabernet Sauvignon and
                        Sangiovese, by 1987 Fattoria Le Pupille released its first vintage of the now famous 1987
                        Saffredi - a xx blend. Elisabetta had been at the vineyard for just seven years. The estate’s
                        first super Tuscan has been born.
                        <br><br>
                        In 1992 she was named the first female president Morellino di Scansano Consortium along with
                        their of ‘Winemaker of the Year’ award. Uner her steerage, the estate has grown from a tiny two
                        hectacres to the 75-hectacre of vineyards that that it is today (the estate is a mssive
                        420-hetacres in total, with arable and olive trees making up the remainer).
                    </div>

                    <div class="howto-title2">Stupendo Saffreti!</div>
                    <div class="howto-text">
                        She might be using French grapes bit the wine is all-Italian. What started off as a pure
                        Cabernet Savignon has had varying amounds of Merlot, Syrah and Alicante added (and substracted)
                        throughout the past 25 years and today Elisabetta has settled on a Cabernet Sauvignon, Merlot
                        and Petit Verdot blend.
                        <br><br>
                        Fattoria Le Pupille has eight appellations to its name, but it is the Safretti that captures our attentions from both a oenological and investment point of view. The blend has slowly evolved
                        from that first bottle (in Q2 2019 just one bottle of the famous wine was avaialbe on the
                        secondary market, at a very reasonable €100) into one of the most coveted fine wines on the
                        market.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FattoriaLePupille",
    head: {
        title: 'Fattoria Le Pupille | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exquisite wines from Fattoria Le Pupille, a renowned Tuscany wine producer known for their exceptional winemaking techniques and high-quality grapes. Indulge in their classic reds, whites and roses and taste the essence of Tuscany in every sip.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
